import { render } from "./GhgEmission.vue?vue&type=template&id=6d502760&scoped=true"
import script from "./GhgEmission.vue?vue&type=script&lang=ts"
export * from "./GhgEmission.vue?vue&type=script&lang=ts"

import "./GhgEmission.vue?vue&type=style&index=0&id=6d502760&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d502760"

export default script